import {
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  NOTIFY_EXPIRED_TOKEN,
} from '../constants/reset-password';

export const initialState = {
  isSaving: false,
  confirmed: false,
  message: null,
  tokenError: false,
};

/**
 * Returns an appropriate error message, which is either the server's message or
 * a generic "something went wrong" message.
 * @param {Object|String} payload the failure action's payload
 * @returns {String} the error message.
 */
function processFailureMessage(payload) {
  if (payload && payload.message) {
    return payload.message;
  }

  /* TODO: i18n */
  return 'There was a problem sending your request. Please try again later.';
}

/**
 * @param {Object} state
 * @param {Object} action
 * @returns {Object} state
 */
export function resetPassword(state = initialState, action = {}) {
  switch (action.type) {
    case RESET_PASSWORD:
      return {
        ...state,

        isSaving: true,
        message: null,
      };

    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,

        isSaving: false,
        confirmed: true,
        message: null,
      };

    case RESET_PASSWORD_FAILURE:
      return {
        ...state,

        isSaving: false,
        message: processFailureMessage(action.payload),
      };

    case NOTIFY_EXPIRED_TOKEN:
      return {
        ...state,

        tokenError: true,
        message: processFailureMessage(action.payload),
      };

    default:
      return state;
  }
}
